import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SkateboardingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"skateboarding"}/>
}
